module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-custom1 "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "myNavbar"
    }
  }, [(_vm.currentUser == 'admin@hydro-ware.com') ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.currentUser == 'admin@hydro-ware.com') ? _c('li', [_c('a', [_vm._v("  ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentUser != 'admin@hydro-ware.com') ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "active",
    class: {
      'hydroware-ishidden': _vm.displayDashboardChoice() == false
    }
  }, [_vm._m(1)]), _vm._v(" "), (_vm.displayComplianceChoice() == true) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.displaySafetyPlanChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/Safetyplan-management"
    }
  }, [_vm._v("\n                Safety Plan\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayComplianceDocChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/compliancedoc-mangement"
    }
  }, [_vm._v("\n                Documents\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayMAHCChecklistChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/startchecklist"
    }
  }, [_vm._v("\n                MAHC Checklist\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayMAHCWebsiteChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "https://www.cdc.gov/mahc",
      "target": "_blank"
    }
  }, [_vm._v("\n                MAHC\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayMAHCSearchChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "https://www.cmahc.org/search-the-mahc.php",
      "target": "_blank"
    }
  }, [_vm._v("\n                Search MAHC\n                ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayRiskManagementChoice() == true) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.displayRiskManagementChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/risk-management"
    }
  }, [_vm._v("\n                Potential Hazards\n                ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayHealthAndSafetyChoice() == true) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.displayReadingsAndTasks() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/chemicalrecord"
    }
  }, [_vm._v(" \n                Readings & Tasks\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayMaintenance() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/maintenance-items"
    }
  }, [_vm._v("\n                Maintenance\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayIncidents() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/incidents"
    }
  }, [_vm._v("\n                Incidents\n                ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayPersonnelChoice() == true) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._m(6), _vm._v(" "), (_vm.displayProfileChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/addpersonnel"
    }
  }, [_vm._v("\n                Profile\n                ")])]) : _vm._e(), _vm._v(" "), _vm._m(7)])]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.displayAdministrationChoice() == true) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(9), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.displayInventoryChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/new-inventory"
    }
  }, [_vm._v("\n                Inventory\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displaySuppliersChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/suppliers"
    }
  }, [_vm._v("\n                Suppliers\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayStaffTrainingChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("Staff Training")])]) : _vm._e(), _vm._v(" "), (_vm.displayActivitiesChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/activitylist"
    }
  }, [_vm._v("Activities")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displaySettingsChoice() == true) ? _c('li', {
    staticClass: "dropdown",
    on: {
      "click": _vm.hideDropdown
    }
  }, [_vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.currentUser == 'admin@hydro-ware.com') ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/usermanagement"
    }
  }, [_vm._v("Administrator")])]) : _vm._e(), _vm._v(" "), (_vm.displaySecurityChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("\n                Security\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayManageFacilityChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/managelocation"
    }
  }, [_vm._v("\n                Manage Facility\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayManageVenueChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/managepools"
    }
  }, [_vm._v("\n                Manage Venue\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayFacilitySchedulingChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("\n                Facility Scheduling\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayPositionsChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/positions"
    }
  }, [_vm._v("\n                Positions\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayCertificatesChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/certificates"
    }
  }, [_vm._v("\n                Certificates\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayEvaluationsChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "href": "/#/evaluationmanagement"
    }
  }, [_vm._v("\n                Evaluations\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayTemplatesChoice() == true) ? _c('li', {
    staticClass: "dropdown-submenu",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('a', {
    staticClass: "test",
    style: (_vm.templateStyle),
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": _vm.templateDropdown
    }
  }, [_c('span', {
    staticClass: "fa fa-caret-left",
    attrs: {
      "float": "left"
    }
  }), _vm._v(" \n                  Templates\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "top": "0",
      "right": "100%",
      "margin-top": "-1px"
    },
    style: (_vm.dropStyle)
  }, [(_vm.displayManageTemplatesChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "tabindex": "-1",
      "href": "/#/chemicalsettings"
    }
  }, [_vm._v("\n                    Manage Templates\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.displayManageCustomReadingsChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "tabindex": "-1",
      "href": "/#/customreadings"
    }
  }, [_vm._v("\n                    Manage Custom Readings\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.displayManageCustomMaintenanceChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "tabindex": "-1",
      "href": "/#/custommaintenance"
    }
  }, [_vm._v("\n                    Manage Custom Maintenance\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.displayManageCustomTasksChoice() == true) ? _c('li', [_c('a', {
    attrs: {
      "tabindex": "-1",
      "href": "/#/customtasks"
    }
  }, [_vm._v("\n                    Manage Custom Task\n                    ")])]) : _vm._e()])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#myNavbar"
    }
  }, [_c('span', {
    staticClass: "fa fa-bars",
    staticStyle: {
      "font-size": "20px",
      "color": "white"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/#/dashboard"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/dashboard_small.png")
    }
  }), _vm._v(" \n              Dashboard\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/compliance_small.png")
    }
  }), _vm._v(" \n              Compliance \n              "), _c('span', {
    staticClass: "fa fa-caret-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/risk_small.png")
    }
  }), _vm._v(" \n              Risk Management\n              "), _c('span', {
    staticClass: "fa fa-caret-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/safety_small.png")
    }
  }), _vm._v(" \n              Health and Safety\n              "), _c('span', {
    staticClass: "fa fa-caret-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/personnel_small.png")
    }
  }), _vm._v(" \n              Personnel\n              "), _c('span', {
    staticClass: "fa fa-caret-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("\n                Schedule\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/patrons_small.png")
    }
  }), _vm._v(" Patrons"), _c('span', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("Memberships")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/#/comingsoon"
    }
  }, [_vm._v("\n                Rentals\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/admin_small.png")
    }
  }), _vm._v("\n              Administration \n              "), _c('span', {
    staticClass: "fa fa-caret-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "nav_icon",
    attrs: {
      "src": require("../../assets/images/honeycomb/settings_small.png")
    }
  }), _vm._v(" \n              Settings\n              "), _c('span', {
    staticClass: "fa fa-caret-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f32ba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar/navigation_bar.vue
// module id = 801
// module chunks = 1